/**
 * 📄 Base payment method type that each payment method should inherit
 */
export default interface PaymentMethod {}

/**
 * 🎨 Possible types of payment methods
 */
export enum PaymentMethodType {
  Card = "card",
  Sepa = "sepa_debit",
  OBT = "OBT"
}